import * as React from 'react';
import Button from '@doordash/component-button';
import { Text, InlineChildren } from '@doordash/design-language';
import InfoBanner, { BannerType } from '../InfoBanner';
import { CONTACT_SALES_URL } from '../../../constants/values';
import { TeamAccountMemberLimitReachedStrings as strings } from './TeamAccountMemberLimitReachedStrings';
import { TeamAccountMemberLimitReachedTestId } from '../../testId';
var TeamAccountMemberLimitReachedBanner = function (_a) {
    var remainingTeamMemberSlots = _a.remainingTeamMemberSlots, teamAccountId = _a.teamAccountId;
    return (React.createElement(InfoBanner, { testId: TeamAccountMemberLimitReachedTestId.Banner, justification: InlineChildren.Justification.FlexStart, bannerType: BannerType.ERROR, bannerText: React.createElement(React.Fragment, null,
            remainingTeamMemberSlots === 1
                ? strings.canOnlyAddCountToTeam.singleAdd(remainingTeamMemberSlots)
                : strings.canOnlyAddCountToTeam.multipleAdd(remainingTeamMemberSlots),
            ' ',
            React.createElement(Button, { isInline: true, size: Button.Sizes.Small, type: Button.Types.Link, tag: "a", href: CONTACT_SALES_URL(teamAccountId), target: "_blank", rel: "noreferrer" },
                React.createElement(Text, null, strings.contactSales())),
            ' ',
            strings.upgradePlan()), bannerTitle: strings.limitationErrorBannerTitle() }));
};
export default TeamAccountMemberLimitReachedBanner;
